import { Link } from 'react-router-dom';
import { categories, mainSiteUrl } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="py-16 md:py-20 px-4 md:px-10 bg-foreground-900 text-background-50">
      <div className="max-w-screen-xl mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <h3 className="text-xl font-heading font-semibold tracking-tight">
              GTBuy Sheet
            </h3>
            <p className="mt-3 text-sm text-background-50/60 leading-relaxed max-w-xs">
              Your smart product comparison platform. Discover the best deals across 14 curated shopping categories.
            </p>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 mt-5 px-5 py-2.5 text-sm font-medium bg-accent-500 text-background-50 rounded-full hover:bg-accent-600 transition-all whitespace-nowrap cursor-pointer"
            >
              buy it now
              <i className="ri-arrow-right-up-line text-sm"></i>
            </a>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 tracking-wide uppercase mb-4">Categories</h4>
            <ul className="space-y-2">
              {categories.slice(0, 7).map((cat) => (
                <li key={cat.slug}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-background-50/60 hover:text-accent-400 transition-colors"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 tracking-wide uppercase mb-4">More Categories</h4>
            <ul className="space-y-2">
              {categories.slice(7).map((cat) => (
                <li key={cat.slug}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-background-50/60 hover:text-accent-400 transition-colors"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 tracking-wide uppercase mb-4">Guides & Resources</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-background-50/60 hover:text-accent-400 transition-colors">Home</Link>
              </li>
              <li>
                <Link to="/article/gtbuy-spreadsheet-guide" className="text-sm text-background-50/60 hover:text-accent-400 transition-colors">Shopping Guide</Link>
              </li>
              <li>
                <Link to="/article/gtbuy-shopping-tips-2026" className="text-sm text-background-50/60 hover:text-accent-400 transition-colors">Shopping Tips</Link>
              </li>
              <li>
                <Link to="/article/gtbuy-sheet-beginners" className="text-sm text-background-50/60 hover:text-accent-400 transition-colors">Beginner Guide</Link>
              </li>
              <li>
                <Link to="/article/gtbuy-sheet-faq" className="text-sm text-background-50/60 hover:text-accent-400 transition-colors">FAQ</Link>
              </li>
              <li>
                <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-sm text-background-50/60 hover:text-accent-400 transition-colors">Main Store</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-50/40">
            &copy; {new Date().getFullYear()} gtbuy.wtf. All rights reserved. Built for smart shoppers.
          </p>
          <div className="flex items-center gap-3">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/10 text-background-50/50 hover:bg-accent-500 hover:text-background-50 transition-all cursor-pointer"
            >
              <i className="ri-shopping-bag-line text-sm"></i>
            </a>
            <Link
              to="/article/gtbuy-spreadsheet-guide"
              className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/10 text-background-50/50 hover:bg-accent-500 hover:text-background-50 transition-all cursor-pointer"
            >
              <i className="ri-book-open-line text-sm"></i>
            </Link>
          </div>
        </div>

        <div className="mt-10 text-center">
          <span className="text-6xl md:text-8xl font-heading font-bold text-background-50/5 select-none">
            GTBUY
          </span>
        </div>
      </div>
    </footer>
  );
}